function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.078a6.922 6.922 0 100 13.844A6.922 6.922 0 008 1.078zM0 8a8 8 0 1116 0A8 8 0 010 8zm5.96-2.04c.211-.21.553-.21.763 0L8 7.239 9.277 5.96a.539.539 0 01.762.762L8.762 8l1.277 1.277a.539.539 0 01-.762.762L8 8.762 6.723 10.04a.539.539 0 01-.762-.762L7.238 8 5.96 6.723a.539.539 0 010-.762z",
  fill: "#2D2D2D"
});
function SvgCirculoconcruz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Circulo con cruz.svg";
export { SvgCirculoconcruz as ReactComponent };